import './FileGrid.scss';

export { default } from './FileGrid';
